import Modal from "../Modal";
import { useSelector } from "react-redux";
import DinamicBoxButton from "../components/DinamicBoxButton";
import { FaMicrophone, FaStop } from "react-icons/fa";

const CommentModal = ({
  openModal, 
  setOpenModal, 
  selectedService, 
  setSelectedService, 
  newComment, 
  setNewComment, 
  uploadingAudio,
  handleAddComment,
  isDictating,
  interimTranscript,
  onToggleDictation,
  type
}) => {
  const user = useSelector((state) => state.auth.user)

  return (
    <Modal // Modal de comentarios del proyecto
      activeModal={openModal}
      onClose={() => { setOpenModal(false); setSelectedService({}); setNewComment(""); if (isDictating && onToggleDictation) onToggleDictation(false); }}
      title="Comentarios proyecto"
      className="max-w-3xl"
      centered
    >
      <div className="flex flex-col gap-2">

        <div className="text-xs text-gray-800 font-semibold text-lg">
          <span className="font-bold">Cliente: </span>
          <span className="font-light">{selectedService?.cotizacion?.cliente?.nombreComercial}</span>
        </div>

        <div className="text-xs text-gray-800 font-semibold text-lg">
          <span className="font-bold">Servicio: </span>
          <span className="font-light">{selectedService?.servicio?.name}</span>
        </div>

        <h3 className="text-xs font-bold text-gray-700 mt-3">Comentarios:</h3>
        
        {/* Sección de comentarios */}
        <div className="max-h-[600px] overflow-y-auto">
          {selectedService?.comentariosOperativa?.map((comment, index) => (
            <div key={index} className="mb-2 px-4 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">

              <div className="flex flex-row justify-between items-center space-x-3 mb-2">
                <div className="flex flex-row gap-2 items-center justify-center">
                  <img
                    src={comment?.usuario?.foto?.url || user?.foto?.url}
                    alt={comment?.usuario?.nombre || user?.nombre}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <span className="text-xs font-semibold text-gray-800">{comment?.usuario?.name || user.name} - <span className="text-xs font-light text-gray-600 lowercase">{comment?.usuario.puesto || user.puesto}</span></span>
                  {comment?.type === 'updateStatus' && (
                    <span className="ml-2 inline-flex items-center text-[10px] px-2 py-0.5 rounded bg-sky-50 text-sky-500 border border-sky-200">Servicio congelado</span>
                  )}
                </div>
                <div className="text-xs text-gray-500">{new Date(comment.fecha).toLocaleString()}</div>
              </div>
              {comment?.comentario && (
                <div className="text-gray-700 text-xs border bordar-gray-200 rounded-md px-2 py-1">{comment.comentario}</div>
              )}
              {(comment?.audioUrl || comment?.audio?.url) && (
                <audio controls className="w-full mt-2">
                  <source src={comment?.audioUrl || comment?.audio?.url} />
                  Tu navegador no soporta el elemento de audio.
                </audio>
              )}
            </div>
          ))}
        </div>

        {/* Sección para agregar un nuevo comentario */}
        <div className="mt-3">
          <h3 className="text-xs font-bold text-gray-700">Añadir comentario:</h3>
          <div className="flex flex-row items-start gap-2">
            <div className="w-full flex flex-col flex-1">
              <textarea
                className="w-full p-3 mt-2 border text-xs border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Escribe tu comentario aquí..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
            </div>
            <div className="flex flex-col items-stretch mt-2 gap-2">
              {isDictating ? (
                <DinamicBoxButton
                  action={() => onToggleDictation && onToggleDictation(false)}
                  icon={<FaStop className="text-[12px]"/>}
                  color="red"
                  content="Pausar transcripción"
                  padding="2.5"
                />
              ) : (
                <DinamicBoxButton
                  action={() => onToggleDictation && onToggleDictation(true)}
                  icon={<FaMicrophone className="text-[12px]"/>}
                  color="green"
                  content="Iniciar transcripción"
                  padding="2.5"
                />
              )}
            </div>
          </div>
          {isDictating && (
            <div className="text-[10px] text-gray-500 mt-2">Dictado: {interimTranscript || "escuchando..."}</div>
          )}
          <button
            disabled={uploadingAudio}
            onClick={handleAddComment}
            className="mt-3 px-4 py-2 bg-blue-600 disabled:opacity-70 text-xs text-white rounded-md hover:bg-blue-700 focus:outline-none"
          >
            {uploadingAudio ? 'Subiendo audio...' : 'Agregar Comentario'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default CommentModal